import { fromJS } from 'immutable';

import ServiceRecord from 'records/service';
import { createSymbols } from 'utils/helpers';
import { collectionReducer } from 'utils/reducerGenerator';

export const {
    EDIT_SERVICE,
    UPDATE_SERVICE,
    UPDATE_SERVICE_FAIL,
    UPDATE_SERVICE_SUCCESS,
} = createSymbols([
    'EDIT_SERVICE',
    'UPDATE_SERVICE',
    'UPDATE_SERVICE_FAIL',
    'UPDATE_SERVICE_SUCCESS',
]);

const editService = (state, action) => {
    const record = action.value;
    let data = state.get('data');
    const key = data.findKey(
        (s) => record.get('service') === s.get('service')
    );

    if (key > -1) {
        data = data.set(key, record);
    } else {
        data = data.push(record);
    }

    return state.set('data', data);
};
const updateServiceSuccess = (state, { payload }) => {
    const apiResponse = payload.data;
    return state.setIn(
        ['data', apiResponse.service],
        ServiceRecord(fromJS(apiResponse))
    );
};

export const { reducer, types } = collectionReducer(
    {
        namespace: 'SERVICE',
        transformer: ServiceRecord,
    },
    {
        [EDIT_SERVICE]: editService,
        [UPDATE_SERVICE_SUCCESS]: updateServiceSuccess,
    }
);

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/services/reducer.js